import { createAction, props } from '@ngrx/store';

export const registrarCambioFocun = createAction(
  '[Onboarding] Registrar Cambio Campo Focun',
  props<{ 
    id: number; 
    campo: string; 
    valorAnterior: any; 
    valorNuevo: any 
  }>()
);

export const limpiarCambiosFocun = createAction(
  '[Onboarding] Limpiar Cambios Pendientes'
);
